module.exports = __webpack_public_path__ + "static/media/location.1c8c6aea.svg";